import React, { PropsWithChildren, useState } from 'react';
import Toast from '@app/component/overlays/toaster/Toast';
import Toaster from '@app/component/overlays/toaster/Toaster';
import _uniqueId from 'lodash/uniqueId';
import ToasterContext from '@app/component/overlays/toaster/context/ToasterContext';
import { useTranslation } from '@app/component/translation/Translation';

export const ToasterContextProvider: React.FunctionComponent<PropsWithChildren> = ({ children }) => {
	const [toasts, setToasts] = useState<Toast[]>([]);
	const { t } = useTranslation();

	const addToast = (toast: Toast) => {
		setToasts((toasts) => [...toasts, toast]);
		setTimeout(() => setToasts((toasts) => toasts.slice(1)), 3000);
	};

	const removeToast = (index: number) => {
		setToasts([...toasts.slice(0, index), ...toasts.slice(index + 1)]);
	};

	const info = (title: string, text: string) => {
		addToast({ state: 'info', title: title, text: text });
	};
	const success = (title: string, text: string) => {
		addToast({ state: 'success', title: title, text: text });
	};
	const error = (title: string, text: string) => {
		const translated = typeof text === 'string' && text.startsWith('server.exception.') ? t(text) : text;
		addToast({
			state: 'error',
			title: title,
			text: translated === text && typeof text === 'string' && text.startsWith('server.exception.') ? t('server.exception.unknown') : translated,
		});
	};
	return (
		<ToasterContext.Provider value={{ info, success, error }}>
			{children}
			<div
				aria-live="assertive"
				className="pointer-events-none fixed inset-0 flex items-end justify-start px-4 py-6 z-20 mb-24">
				<div className="flex w-full flex-col items-center space-y-4 max-w-sm">
					{toasts.map((toast, index) =>
						<Toaster key={_uniqueId('toaster_')}
						         index={index}
						         toast={toast}
						         onClose={() => removeToast(index)} />,
					)}
				</div>
			</div>
		</ToasterContext.Provider>
	);
};

export default ToasterContextProvider;
